// Incoming Text mock data (approved HTML:
// Incoming-Text-Consistency-Review-v5.html).
// Text and email cannot inherit the other channel's recipient, subject,
// draft, notes or request. Doug's world: Sarah texts about Duke.

export const INCOMING_TEXT = {
  heroEyebrow: 'CUSTOMER CONVERSATION',
  heroTitle: 'Incoming Text',
  heroContext: 'Confirm Duke’s daily routine · Assigned to Jamie Dorsey',
  purpose: 'Confirm Duke’s daily routine',
  reason: 'Sarah texted asking for help checking Duke’s current Gut X routine.',
  recipient: 'Sarah Mitchell',
  destination: '(615) 555-0148',
  sender: 'Sarah Mitchell',
  sentAt: 'Sep 18, 2:14 PM Central',
  lastMessage:
    'Hey Jamie, Duke is back on grain. What scoop size were we using on Gut X?',
  draft:
    'Hi Sarah, Duke was on 2 oz twice daily. I can confirm or adjust his next shipment if his routine has changed.',
  draftHint: 'Text to (615) 555-0148 · Preference 1',
  channelLabel: 'Text message',
  threadLabel: 'LATEST TEXT MESSAGE',
};
